import { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import Modal from 'react-modal'
import ReactTooltip from 'react-tooltip'
import Slider from 'react-slick'
import moment from 'moment'
import each from 'lodash/each'
import filter from 'lodash/filter'
import isEmpty from 'lodash/isEmpty'
import clone from 'lodash/clone'
import API from '../../api'
import { createUrl } from '../../localized-urls'
import { showItineraryPopup } from '../../actions/main-actions'
import Loader from '../helpers/Loader'
import { FormattedMessage, injectIntl, defineMessages, intlShape } from 'react-intl'
import PromotionLabel from '../helpers/PromotionLabel'
import DateFormat from '../helpers/DateFormat'
import Inclusions from '../helpers/Inclusions'
import PaymentAndCancellation from '../helpers/PaymentsAndCancellation'
import { getRelativePos } from '../../utils'

const sliderConfig = {
  slidesToShow: 3,
  slidesToScroll: 3,
  infinite: false,
  lazyLoad: true,
  dots: true,
  responsive: [{
    breakpoint: 1025,
    settings: {
      arrows: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
    },
  },
  {
    breakpoint: 480,
    settings: {
      arrows: false,
      slidesToShow: 1.5,
      slidesToScroll: 1,
      dots: false,
    },
  }],
}

const msg = defineMessages({
  nightsAboard: {
    id: 'nightsAboard',
    defaultMessage: 'Number of nights aboard',
  },
  approxNumDives: {
    id: 'approxNumDives',
    defaultMessage: 'Approximate number of dives',
  },
  requirements: {
    id: 'requirements',
    defaultMessage: 'Requirements',
  },
  startDate: {
    id: 'startDate',
    defaultMessage: 'Start date',
  },
  departureHarbour: {
    id: 'departureHarbour',
    defaultMessage: 'Departure harbour',
  },
  checkInTimeOnBoat: {
    id: 'checkInTimeOnBoat',
    defaultMessage: 'Check in times on the boat',
  },
  recommendedAirport: {
    id: 'recommendedAirport',
    defaultMessage: 'Recommended airport',
  },
  endDate: {
    id: 'endDate',
    defaultMessage: 'End date',
  },
  arrivalHarbour: {
    id: 'arrivalHarbour',
    defaultMessage: 'Arrival harbour',
  },
  checkOutTimeOnBoat: {
    id: 'checkOutTimeOnBoat',
    defaultMessage: 'Check out times on the boat',
  },
})

function bindItinerary(days) {
  if(!days.length) {
    return []
  }

  var notEmpty = filter(days, function(val) {
    return !isEmpty(val.description)
  })

  if(!notEmpty.length) {
    return []
  }

  if(notEmpty.length > 1) {
    for(var i = 0; i < notEmpty.length; i++) {
      if(i === 0) {
        notEmpty[i].dayStart = 1

        if(notEmpty[i + 1]) {
          notEmpty[i].dayFinish = notEmpty[i + 1].dayStart - 1
        }
      } else if(i !== 0 && notEmpty[i + 1]) {
        notEmpty[i].dayFinish = notEmpty[i + 1].dayStart - 1
      } else if(i !== 0 && !notEmpty[i + 1]) {
        notEmpty[i].dayFinish = days.length
      }
    }

    return notEmpty
  } else {
    return [{
      dayStart: 1,
      dayFinish: days.length,
      description: clone(notEmpty[0]).description,
    }]
  }
}

function selectCertification() {}
function getTimeOptions() {}

const defaultState = {
  loading: true,
  itinerary: {},
  allDaysOpened: false,
  logisticExpanded: false,
  whatsIncludedExpanded: false,
  whatsNotIncludedExpanded: false,
  mandatorySurchargesExpanded: false,
  optionalExtrasExpanded: false,
  goodToKnowExpanded: false,
  paymentExpanded: false,
  info: {},
  showDayDescription: {},
}

class ItineraryPopup extends Component {
  constructor(props) {
    super(props)

    this.state = defaultState

    this.slickRef = React.createRef()
  }

    closeModal = () => {
      window.history.pushState({}, null, window.shopUrl)
      this.props.showItineraryPopup(false)
    }

    componentDidUpdate(prevProps) {
      const {
        countrySlug,
        shopSlug,
        itinerarySlug,
        tripId,
        isCharter,
        dateFrom,
        dateTo,
        duration,
        currency,
        hideFooter,
        current,
        elementToScroll,
        insurance,
        updateUrl,
        isGroupTrip,
      } = this.props.itineraryPopupData

      if(JSON.stringify(prevProps.itineraryPopupData) === JSON.stringify(this.props.itineraryPopupData)) {
        return false
      }

      this.setState(defaultState)

      if(updateUrl) {
        window.history.pushState({}, null, `${window.location.href}${itinerarySlug}/`)
      }

      API(`shop/${countrySlug}/${shopSlug}/itineraries/${itinerarySlug}/`).get().then((itinerary) => {
        let description = {
          beforeTrip: [],
          onBoard: [],
          afterTrip: [],
        }

        each(itinerary.descriptions, (item) => {
          if(item.section === 10) {
            description.beforeTrip.push(item)
          } else if(item.section === 20) {
            description.onBoard.push(item)
          } else if(item.section === 30) {
            description.afterTrip.push(item)
          }
        })

        if(isGroupTrip) {
          itinerary.isNewModelUsed = false
          itinerary.whatsIncluded = false
          itinerary.whatsNotIncluded = false
          itinerary.paymentInformation = false
        }

        this.setState({
          itinerary: {
            ...itinerary,
            id: tripId || null,
            isCharter: isCharter || null,
            startDate: dateFrom,
            endDate: dateTo || moment(dateFrom).add(duration, 'd').utc().format(),
            days: bindItinerary(itinerary.days),
            descriptions: description,
          },
          info: {
            currency,
            hideFooter,
            current,
            countrySlug,
            shopSlug,
            insurance,
          },
          loading: false,
        })

        if(elementToScroll) {
          if(elementToScroll === '#logistics') {
            this.toggleSection('logisticExpanded')
          } else if(elementToScroll === '#included-section') {
            this.toggleSection('whatsIncludedExpanded')
          }

          document.querySelector('.itinerary-popup-content').scrollTop = getRelativePos(document.querySelector(elementToScroll)).top
        }
        ReactTooltip.rebuild()
      })
    }

    toggleDays = () => {
      let days = clone(this.state.showDayDescription)

      each(this.state.itinerary.days, (_, index) => {
        days[`day` + index] = !this.state.allDaysOpened
      })

      this.setState({
        allDaysOpened: !this.state.allDaysOpened,
        showDayDescription: days,
      })
    }

    toggleSection = (type) => {
      this.setState({
        [type]: !this.state[type],
      })
    }

    render() {
      const { itinerary } = this.state
      const { currency, hideFooter, current, countrySlug, shopSlug, insurance } = this.state.info
      const intl = this.props.intl
      const { promotion, price, compareAtPrice } = this.props.itineraryPopupData

      return (<Modal
        isOpen={this.props.itineraryPopupOpen}
        onRequestClose={this.closeModal}
        ariaHideApp={false}
        className='Modal react-itinerary-modal'
        overlayClassName='Overlay'
        contentLabel='Itinerary popup'
      >
        <div className={`itinerary-page-new ${this.state.loading ? 'loading' : ''}`}>
          <div className='itinerary-page__modal-header'>
            <span className='btn-close' onClick={this.closeModal}>&times;</span>
          </div>
          <Loader />
          <ReactTooltip effect='solid' />
          <div className='itinerary-popup-content'>
            <div className='main-title'>
              { itinerary.shopTitle ? (<a className='shop-title'>{itinerary.shopTitle}</a>) : '' }
              <h4 className='title'>{ itinerary.title }</h4>
            </div>
            <div className='main-information'>
              <div className='main-information__section'>
                { itinerary.length
                  ? (<p className='main-information__item'>
                    <i className='font-icons icon-moon itinerary-tooltip' data-tip={intl.formatMessage(msg.nightsAboard)} />
                    <FormattedMessage id='qty_nights' values={{ qty: itinerary.length }} defaultMessage='{qty, plural, one {# night} other {# nights}}' />
                  </p>) : ''
                }
                { itinerary.totalNumberOfDives
                  ? (<p className='main-information__item'>
                    <i className='font-icons divers-icon itinerary-tooltip' data-tip={intl.formatMessage(msg.approxNumDives)} />
                    { itinerary.totalNumberOfDivesMax
                      ? (<FormattedMessage id='min_max_dives' values={{ divesMin: itinerary.totalNumberOfDives, divesMax: itinerary.totalNumberOfDivesMax }} defaultMessage='Approx. { divesMin } - { divesMax } dives' />)
                      : (<FormattedMessage id='min_dives' values={{ divesMin: itinerary.totalNumberOfDives }} defaultMessage='{ divesMin } dives' />)
                    }
                  </p>) : ''
                }
              </div>
              { itinerary.minimalNumberOfDives || itinerary.requiredCertification || itinerary.experienceRequired ? (
                (<div className='main-information__section'>
                  <div className='main-information__item'>
                    <i className='font-icons icon-warning itinerary-tooltip' data-tip={intl.formatMessage(msg.requirements)} />
                    { itinerary.minimalNumberOfDives ? (
                      <p>
                        <FormattedMessage id='dives_recommended' values={{
                          numberOfDives: itinerary.minimalNumberOfDives,
                        }} defaultMessage='{numberOfDives}+ dives recommended' />
                      </p>) : ''
                    }
                    { itinerary.requiredCertification ? (
                      <p>
                        { selectCertification(itinerary.requiredCertification) }
                      </p>) : ''
                    }
                    { itinerary.experienceRequired ? <p>{itinerary.experienceRequired}</p> : ''}
                  </div>
                </div>)
              ) : ''
              }

            </div>
            { promotion ? (
              <div className='deal-information' id='deal-section'>
                <PromotionLabel promotion={promotion} price={price} compareAtPrice={compareAtPrice} />
                <div className='deal-information__description wysiwyg'>
                  <h4>{promotion.title}</h4>
                  <div className='wysiwyg fade-onload'
                    ng-class="{'expanded': showDeals }"
                    hide-content='hide-content'
                    trigger='showDeals'
                    height='150'
                    dangerouslySetInnerHTML={{ __html: promotion.description }}
                  />
                </div>
              </div>
            ) : '' }
            <div className='departure-information'>
              <div className='departure-information__item'>
                <h4><FormattedMessage id='departure' defaultMessage='Departure' /></h4>
                <ul>
                  { itinerary.startDate
                    ? (<li>
                      <i className='font-icons calendar-icon' data-tip={intl.formatMessage(msg.startDate)} />
                      <span>
                        <DateFormat date={itinerary.startDate} format='DD MMM YYYY' />
                      </span>
                    </li>) : ''
                  }
                  {
                    itinerary.portDeparture || itinerary.harbourDepartureTitle
                      ? (<li>
                        <i className='font-icons icon-anchor' data-tip={intl.formatMessage(msg.departureHarbour)} />
                        <span>{ itinerary.harbourDepartureTitle || itinerary.portDeparture }</span>
                      </li>)
                      : ''
                  }
                  {
                    itinerary.checkInFrom
                      ? (<li>
                        <i className='font-icons icon-clock' data-tip={intl.formatMessage(msg.checkInTimeOnBoat)} />
                        <span>{ itinerary.checkInFrom.substr(0, 5) }{ itinerary.checkInTo ? ` – ${itinerary.checkInTo.substr(0, 8)}` : '' }</span>
                      </li>)
                      : ''
                  }
                  {
                    itinerary.checkInFrom && itinerary.checkInOther ? (
                      <li>
                        <i className='font-icons icon-clock' data-tip={intl.formatMessage(msg.checkInTimeOnBoat)} />
                        <span>{ getTimeOptions(itinerary.checkInOther) }</span>
                      </li>
                    ) : ''
                  }
                  { itinerary.airportDepartureTitle
                    ? (<li>
                      <i className='font-icons icon-plane' data-tip={intl.formatMessage(msg.recommendedAirport)} />
                      <span>{ `${itinerary.airportDepartureTitle} (${itinerary.airportDepartureIata})` }</span>
                    </li>) : ''
                  }
                </ul>
              </div>
              <div className='departure-information__item'>
                <h4 translate='translate'><FormattedMessage id='return' defaultMessage='Return' /></h4>
                <ul>
                  { itinerary.endDate
                    ? (<li>
                      <i className='font-icons calendar-icon' data-tip={intl.formatMessage(msg.endDate)} />
                      <span>
                        <DateFormat date={itinerary.endDate} format='DD MMM YYYY' />
                      </span>
                    </li>) : ''
                  }
                  {
                    itinerary.portArrival || itinerary.harbourArrivalTitle
                      ? (<li>
                        <i className='font-icons icon-anchor' data-tip={intl.formatMessage(msg.arrivalHarbour)} />
                        <span>{ itinerary.harbourArrivalTitle || itinerary.portArrival }</span>
                      </li>)
                      : ''
                  }
                  {
                    itinerary.guestDisembarkFrom ? (<li>
                      <i className='font-icons icon-clock' data-tip={intl.formatMessage(msg.checkOutTimeOnBoat)} />
                      <span>{ itinerary.guestDisembarkFrom.substr(0, 5) }{ itinerary.guestDisembarkTo ? ` – ${itinerary.guestDisembarkTo.substr(0, 8)}` : '' }</span>
                    </li>) : ''
                  }
                  {
                    itinerary.guestDisembarkFrom && itinerary.guestDisembarkOther ? (<li>
                      <i className='font-icons icon-clock' data-tip={intl.formatMessage(msg.checkOutTimeOnBoat)} />
                      <span>{ getTimeOptions(itinerary.guestDisembarkOther) }</span>
                    </li>) : ''
                  }
                  {
                    itinerary.airportArrivalTitle ? (<li>
                      <i className='font-icons icon-plane' data-tip={intl.formatMessage(msg.recommendedAirport)} />
                      <span>{ `${itinerary.airportArrivalTitle} (${itinerary.airportArrivalIata})` }</span>
                    </li>) : ''
                  }
                </ul>
              </div>
            </div>
            { itinerary.highlightsDescription
              ? (<div className='itinerary-highlights itinerary-section'>
                <h4 translate='translate'><FormattedMessage id='itineraryHighlights' defaultMessage='Itinerary highlights' /></h4>
                <div className='description wysiwyg' dangerouslySetInnerHTML={{ __html: itinerary.highlightsDescription }} />
              </div>) : ''
            }
            {
              itinerary.isDayByDay
                ? (
                  <Fragment>
                    <div className='itinerary-description-section itinerary-section'>
                      <h4><FormattedMessage id='itineraryDescription' defaultMessage='Itinerary description' /></h4>
                      <span className={`more ${this.state.allDaysOpened ? 'active' : ''}`} onClick={this.toggleDays}>
                        { this.state.allDaysOpened
                          ? <FormattedMessage id='hide_all_days' defaultMessage='Hide all days' />
                          : <FormattedMessage id='show_all_days' defaultMessage='Show every day' />
                        }
                      </span>
                      <div className='itinerary-description wysiwyg'>
                        {
                          itinerary.days.length
                            ? itinerary.days.map((day, index) => {
                              return (
                                <div key={index} className={`font-icons
                                    ${index === 0 ? ' first-day' : ''} 
                                    ${index !== 0 && itinerary.days.length === index + 1 ? ' last-day' : ''}
                                    ${this.state.showDayDescription[`day${index}`] ? ' expanded' : ''}
                                `}>
                                  <p className='title' onClick={() => {
                                    this.setState({
                                      showDayDescription: {
                                        ...this.state.showDayDescription,
                                        [`day${index}`]: !this.state.showDayDescription[`day${index}`],
                                      },
                                    })
                                  }}>
                                    <FormattedMessage id='day' defaultMessage='Day' />&nbsp;{ day.dayStart } { day.dayStart != day.dayFinish ? ' - ' + day.dayFinish : '' }
                                    <span className={`more ${this.state.showDayDescription[`day${index}`] ? 'active' : ''}`} />
                                  </p>
                                  { this.state.showDayDescription[`day${index}`] ? (
                                    <div dangerouslySetInnerHTML={{ __html: day.description }} />
                                  ) : ''}
                                </div>
                              )
                            })
                            : (<div><FormattedMessage id='itinerary_coming_soon' defaultMessage='The itinerary description is coming soon, in the meantime please do not hesitate to contact us.' /></div>)
                        }
                      </div>

                      <div className='image-list'>
                        {
                          itinerary.photos.map((image, index) => {
                            return (<div className='image-list__item' key={index}>
                              <img className='pointer cabin-image' src={image.thumbnails.DOSliderMobilePort} title={image.title ? image.title : 'Itinerary'} width='100%' />
                            </div>)
                          })
                        }
                      </div>
                    </div>
                  </Fragment>
                ) : ''
            }
            {itinerary.marineLife && itinerary.marineLife.length
              ? (<div className='marine-life-pictures itinerary-section' style={{ width: '100%' }}>
                <h4><FormattedMessage id='marine_life' defaultMessage='Iconic marine life you could encounter' /></h4>
                <Slider {...sliderConfig}>
                  {
                    itinerary.marineLife.map((critter, index) => {
                      return (
                        <div className='marine-life-pictures__item' key={index}>
                          <div className='img-wrapper'>
                            <img src={critter.thumbnails.WizardSpeciesSmall} />
                          </div>
                          <span className='title'>{critter.title}</span>
                        </div>
                      )
                    })
                  }
                </Slider>
              </div>) : ''
            }
            { itinerary.logistics && !itinerary.useNewLogisticsData ? (
              <div className='itinerary-section itinerary-logistics collapsed-section' id='logistics'>
                <h4 onClick={() => this.toggleSection('logisticExpanded')} className={this.state.logisticExpanded ? 'active' : ''}>
                  <FormattedMessage id='how_to_get_there' defaultMessage='How to get there' />
                </h4>
                { this.state.logisticExpanded ? (
                  <div className='description wysiwyg' dangerouslySetInnerHTML={{ __html: itinerary.logistics }} />
                ) : '' }
              </div>) : ''
            }
            {
              itinerary.descriptions && itinerary.useNewLogisticsData
                ? (
                  <div className='itinerary-section collapsed-section' id='logistics'>
                    <h4 onClick={() => this.toggleSection('logisticExpanded')} className={this.state.logisticExpanded ? 'active' : ''}>
                      <FormattedMessage id='how_to_get_there' defaultMessage='How to get there' />
                    </h4>
                    { this.state.logisticExpanded ? (
                      <div className='itinerary-section-details fade-onload'>
                        { itinerary.descriptions.beforeTrip && itinerary.descriptions.beforeTrip.length ? (
                          <div className='description wysiwyg' ng-if='ctrl.itinerary.descriptions.beforeTrip.length'>
                            <p className='bold'>
                              <FormattedMessage id='begining_of_trip' defaultMessage='The beginning of your trip' />
                            </p>
                            <ul>
                              {
                                itinerary.descriptions.beforeTrip.map((item, key) => {
                                  return (<li key={key}>{ item.isAutogenerated ? item.autogeneratedContents : item.contents }</li>)
                                })
                              }
                            </ul>
                          </div>
                        ) : '' }
                        { itinerary.descriptions.onBoard && itinerary.descriptions.onBoard.length ? (
                          <div className='description wysiwyg'>
                            <p className='bold'>
                              <FormattedMessage id='during_trip' defaultMessage='During your trip' />
                            </p>
                            <ul>
                              {
                                itinerary.descriptions.onBoard.map((item, key) => {
                                  return (<li key={key}>{ item.isAutogenerated ? item.autogeneratedContents : item.contents }</li>)
                                })
                              }
                            </ul>
                          </div>) : '' }
                        { itinerary.descriptions.afterTrip && itinerary.descriptions.afterTrip.length
                          ? (<div className='description wysiwyg'>
                            <p className='bold'>
                              <FormattedMessage id='end_of_trip' defaultMessage='The end of your trip' />
                            </p>
                            <ul>
                              {
                                itinerary.descriptions.afterTrip.map((item, key) => {
                                  return (<li key={key}>{ item.isAutogenerated ? item.autogeneratedContents : item.contents }</li>)
                                })
                              }
                            </ul>
                          </div>) : ''}
                        {
                          itinerary.otherLogisticsInfo
                            ? (<div className='description wysiwyg'>
                              <p className='bold'>
                                <FormattedMessage id='other_info' defaultMessage='Other info' />
                              </p>
                              <div dangerouslySetInnerHTML={{ __html: itinerary.otherLogisticsInfo }} />
                            </div>) : ''
                        }
                      </div>) : '' }
                  </div>
                ) : ''
            }
            {
              !itinerary.isNewModelUsed && itinerary.whatsIncluded ? (
                <div className='itinerary-section itinerary-logistics collapsed-section' id='included-section'>
                  <h4 onClick={() => this.toggleSection('whatsIncludedExpanded')} className={this.state.whatsIncludedExpanded ? 'active' : ''}>
                    <FormattedMessage id='whats_included' defaultMessage='What`s included' />
                  </h4>
                  { this.state.whatsIncludedExpanded ? (
                    <Fragment>
                      <div className='circled-list' dangerouslySetInnerHTML={{ __html: itinerary.whatsIncluded }} />
                      <i className='note-text'><FormattedMessage id='note.price' defaultMessage='Note: all listed prices are per person' /></i>
                    </Fragment>
                  ) : '' }
                </div>) : ''
            }
            {
              !itinerary.isNewModelUsed && itinerary.whatsNotIncluded ? (
                <div className='itinerary-section itinerary-logistics collapsed-section'>
                  <h4 onClick={() => this.toggleSection('whatsNotIncludedExpanded')} className={this.state.whatsNotIncludedExpanded ? 'active' : ''}>
                    <FormattedMessage id='whats_not_included' defaultMessage='What`s not included' />
                  </h4>
                  { this.state.whatsNotIncludedExpanded ? (
                    <Fragment>
                      <div className='circled-list' dangerouslySetInnerHTML={{ __html: itinerary.whatsNotIncluded }} />
                      <i className='note-text'><FormattedMessage id='note.price' defaultMessage='Note: all listed prices are per person' /></i>
                    </Fragment>
                  ) : '' }
                </div>) : ''
            }
            {
              itinerary.isNewModelUsed ? (
                <Fragment>
                  <div className='itinerary-section collapsed-section' id='included-section'>
                    <h4 onClick={() => this.toggleSection('whatsIncludedExpanded')} className={this.state.whatsIncludedExpanded ? 'active' : ''}>
                      <FormattedMessage id='whats_included' defaultMessage='What`s included' />
                    </h4>
                    { this.state.whatsIncludedExpanded
                      ? (<div className='itinerary-section-details'>
                        <Inclusions included startDate={itinerary.startDate} items={itinerary.whatsIncludedNew} insurance={insurance} />
                        <i className='note-text'><FormattedMessage id='note.price' defaultMessage='Note: all listed prices are per person' /></i>
                      </div>) : ''
                    }
                  </div>
                  <div className='itinerary-section collapsed-section'>
                    <h4 onClick={() => this.toggleSection('mandatorySurchargesExpanded')} className={this.state.mandatorySurchargesExpanded ? 'active' : ''}>
                      <FormattedMessage id='whats_not_included' defaultMessage='What`s not included' />
                    </h4>
                    { this.state.mandatorySurchargesExpanded
                      ? (<div className='itinerary-section-details'>
                        <Inclusions showPrices startDate={itinerary.startDate} type='mandatoryInAdvance' currency={currency} payedInAdvance items={itinerary.mandatoryInAdvance} />
                        <Inclusions showPrices startDate={itinerary.startDate} type='mandatoryOnBoard' currency={currency} items={itinerary.mandatoryOnBoard} />
                        <i className='note-text'><FormattedMessage id='note.price' defaultMessage='Note: all listed prices are per person' /></i>
                      </div>) : ''
                    }
                  </div>
                  <div className='itinerary-section collapsed-section'>
                    <h4 onClick={() => this.toggleSection('optionalExtrasExpanded')} className={this.state.optionalExtrasExpanded ? 'active' : ''}>
                      <FormattedMessage id='optional_extras' defaultMessage='Optional extras' />
                    </h4>
                    { this.state.optionalExtrasExpanded
                      ? (<div className='itinerary-section-details'>
                        <Inclusions showPrices startDate={itinerary.startDate} payedInAdvance type='optionalInAdvance' currency={currency} items={itinerary.optionalInAdvance} />
                        <Inclusions showPrices startDate={itinerary.startDate} type='optionalBookableAdvancePaidOnBoard' currency={currency} items={itinerary.optionalBookableAdvancePaidOnBoard} />
                        <Inclusions showPrices startDate={itinerary.startDate} type='optionalOnBoard' currency={currency} items={itinerary.optionalOnBoard} />
                        <i className='note-text'><FormattedMessage id='note.price' defaultMessage='Note: all listed prices are per person' /></i>
                      </div>) : ''
                    }
                  </div>
                </Fragment>) : ''
            }
            { itinerary.goodToKnow ? (
              <div className='itinerary-section itinerary-logistics collapsed-section'>
                <h4 onClick={() => this.toggleSection('goodToKnowExpanded')} className={this.state.goodToKnowExpanded ? 'active' : ''}>
                  <FormattedMessage id='good_to_know' defaultMessage='Good to know' />
                </h4>
                { this.state.goodToKnowExpanded ? (
                  <div className='description wysiwyg' dangerouslySetInnerHTML={{ __html: itinerary.goodToKnow }} />
                ) : '' }
              </div>) : ''
            }
            { itinerary.paymentInformation ? (
              <div className='itinerary-section itinerary-logistics collapsed-section'>
                <h4 onClick={() => this.toggleSection('paymentExpanded')} className={this.state.paymentExpanded ? 'active' : ''}>
                  <FormattedMessage id='payment_and_cancellation' defaultMessage='Payment & Cancellation terms' />
                </h4>
                { this.state.paymentExpanded ? (
                  <div className='itinerary-section-details' ng-show='paymentExpanded'>
                    <PaymentAndCancellation
                      currency={currency}
                      paymentInformation={itinerary.paymentInformation}
                      milestones={itinerary.milestones}
                      isCustomCancellation={itinerary.isCustomCancellation}
                      cancellationMilestones={itinerary.cancellationMilestones}
                      customCancellationText={itinerary.customCancellationText} />
                  </div>
                ) : '' }
              </div>) : ''
            }
            {/* <div className="itinerary-section" data-sharethis="data-sharethis" url="{$ ctrl.createURL('itinerary', { location: ctrl.info.countrySlug, slug: ctrl.info.slug, itinerarySlug: ctrl.itinerary.slug  }) $}" g-plus="false" email="true" title="{$ ctrl.itinerary.title $}"></div> */}
          </div>
          { !this.state.loading && !hideFooter ? (
            <div className='itinerary-page__modal-footer'>
              { itinerary.id && !itinerary.isCharter && !current ? (
                (<a className='btn-red' href={createUrl('checkout_la', { location: countrySlug, slug: shopSlug }, '?productId=' + itinerary.id)}>
                  <FormattedMessage id='cabin_prices' defaultMessage='Cabin prices' />
                </a>)
              ) : ''
              }
              { !itinerary.id && !itinerary.isCharter && !current ? (
                (<a className='btn-red' href={createUrl('checkout_la', { location: countrySlug, slug: shopSlug })}>
                  <FormattedMessage id='trip_schedule' defaultMessage='Trip schedule' />
                </a>)
              ) : ''
              }
              {/* <a className="btn-red popup-close" ng-hide="ctrl.current" ng-if="!ctrl.itinerary.id &amp;&amp; !ctrl.itinerary.isCharter" ng-href="{$ ::ctrl.createURL('checkout_la', { location: ctrl.info.countrySlug, slug:ctrl.info.slug}, '?itinerary='+ ctrl.itinerary.id) $}" translate="translate">Trip schedule</a>
                <a className="btn-red popup-close" ng-hide="ctrl.current" live-chat-click="live-chat-click" ng-if="ctrl.itinerary.isCharter" translate="translate">CONTACT US FOR PRICES</a></div> */}
            </div>
          ) : '' }
        </div>
      </Modal>)
    }
}

ItineraryPopup.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(connect(
  state => ({
    itineraryPopupOpen: state.itineraryPopupOpen,
    itineraryPopupData: state.itineraryPopupData,
  }),
  { showItineraryPopup }
)(ItineraryPopup))
